// TODO: fix this import - 82948
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { ChannelsEmpty, EntityList } from 'features/channels/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useProgramsInfiniteQuery } from 'features/programs/queries';

type P = {
  getPathToProgramDetail: (id: string) => string;
  navigateToJoinedPrograms: () => Promise<void>;
  organizationId?: string;
};

const AllPrograms = ({ getPathToProgramDetail, navigateToJoinedPrograms, organizationId }: P) => {
  const {
    data: allProgramsData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useProgramsInfiniteQuery({
    filter: {
      organizationId,
      scope: 'channels',
    },
    pagination: { pageSize: 12 },
  });

  const allPrograms = allProgramsData?.pages.flat().flatMap((programsPaginated) => programsPaginated.data);

  return (
    <EntityList
      empty={<ChannelsEmpty navigateToJoined={navigateToJoinedPrograms} scope="programs" />}
      entities={allPrograms?.map((program) => ({
        data: program,
        type: 'Program',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToProgramDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll}
    />
  );
};

export default AllPrograms;
